import axios from "axios";
import axiosInstance from "../../../../../../Utils/axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const grnInvoiceURL = `api/v1/purchase-app/grn-additional-invoice`;
//obtaining the paginated data
export const getGrnInvoice = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${grnInvoiceURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllGrnInvoice = () => axiosInstance.get(`${grnInvoiceURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageGrnInvoice = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${grnInvoiceURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//ge Additional Cost List
export const getAdditionalCostList = () =>
  axiosInstance.get(`api/v1/purchase-app/grn-additional-invoice-cost/list?ordering=-id&isActive=true`);
//get by id
export const getGrnDetailById = (id) => axiosInstance.get(`api/v1/purchase-app/grn/retrieve/${id}`);
//get by id
export const getGrnInvoiceById = (id) => axiosInstance.get(`${grnInvoiceURL}/retrieve/${id}`);

//creating function
export const createGrnInvoice = (body) => axiosInstance.post(`${grnInvoiceURL}/create`, body);
//updating function
export const updateGrnInvoice = (id, body) => axiosInstance.patch(`${grnInvoiceURL}/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${grnInvoiceURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataGrnInvoiceName = (e, cancelToken) =>
  axiosInstance.get(`${grnInvoiceURL}?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
